import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from '@/config'
import FastClick from 'fastclick'
import VHtmlPanel from '@/components/VHtmlPanel'

// import VueAMap from 'vue-amap'
// import { lazyAMapApiLoaderInstance } from 'vue-amap'

// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: '51d7b88237507c89371c1d3424afa4ca',
//   plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.GeometryUtil', 'AMap.MapType'],
//   v: '1.4.4',
// })

import InfiniteLoading from 'vue-infinite-loading'
import VueResource from 'vue-resource'
import {
  Search,
  Swipe,
  SwipeItem,
  Button,
  Cell,
  CellGroup,
  Popup,
  Dialog,
  Icon,
  Picker,
  Field,
  List,
  PullRefresh,
  Notify,
  Rate,
  NavBar
} from 'vant'

import VueI18n from 'vue-i18n'
import messages from './assets/lang/index.js'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'cn',
  messages,
})

Vue.use(Cell).use(CellGroup)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Search)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Picker)
Vue.use(Field)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Notify)
Vue.use(Rate)
Vue.use(NavBar)

Vue.prototype.$dialog = Dialog

import VueQriously from 'vue-qriously'

Vue.use(VueQriously)

Vue.use(VueResource)
Vue.use(VHtmlPanel)
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'waveDots',
  },
  slots: {
    noMore: '—— 已经到底了 ——',
    noResult: '暂无数据',
  },
})
Vue.use(require('vue-moment'))

FastClick.attach(document.body)
Vue.prototype.$config = config
Vue.config.productionTip = false
;(function(doc) {
  var docEl = doc.documentElement,
    // resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function() {
      var clientWidth = docEl.clientWidth
      if (!clientWidth) return
      // 设置设计稿的宽度clientWidth为750
      //杭马赛中赛WEB页面 定制 ！！如果要用请打开
      if (clientWidth >= 750) {
        //1  20px = 1rem  1600设计稿的宽度 fontsize 为40px 1rem =
        docEl.style.fontSize = 20 * (clientWidth / 1600) + 'px'
      } else {
        // 设置设计稿的宽度clientWidth为750
        docEl.style.fontSize = 20 * (clientWidth / 375) + 'px'
      }
    }
  if (!doc.addEventListener) return
  // win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
